import { Box, Stack } from "@mui/material";

import { AppToolbarProps } from "./types";

const AppToolbar = ({
  left,
  right,
}: AppToolbarProps) => {
  return (
    <Box
      mb={3}
      sx={{
        p: { xs: 1.5, sm: 2 },
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        bgcolor: "background.default",
      }}
    >
      <Stack
        direction={{
          xs: "column",
          lg: "row",
        }}
        justifyContent="space-between"
        alignItems={{
          xs: "stretch",
          lg: "center",
        }}
        spacing={2}
        sx={{ flexWrap: "wrap" }}
      >
        <Stack
          direction="row"
          spacing={1.5}
          flexWrap="wrap"
          sx={{ flex: "1 1 300px", minWidth: 0, width: { xs: "100%", lg: "auto" } }}
        >
          {left}
        </Stack>

        <Stack
          direction="row"
          spacing={1.5}
          justifyContent="flex-end"
          flexWrap="wrap"
          sx={{ flex: "1 1 560px", minWidth: 0, width: { xs: "100%", lg: "auto" } }}
        >
          {right}
        </Stack>
      </Stack>
    </Box>
  );
};

export default AppToolbar;
